import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const RollsRoundDetailModalLazy = React.lazy(() =>
  import('./RollsRoundDetailModal').then((m) => ({ default: m.RollsRoundDetailModal })),
);
type RollsRoundDetailModalProps = React.ComponentProps<
  typeof import('./RollsRoundDetailModal').RollsRoundDetailModal
>;

NiceModal.register(
  MODALS.ROLLS_ROUND_DETAIL,
  NiceModal.create((props: RollsRoundDetailModalProps) => (
    <Suspense fallback={null}>
      <RollsRoundDetailModalLazy {...props} />
    </Suspense>
  )),
);
